import pattern from '../../pattern.svg';

// Libraries
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Global state and services
import StripePortal from '../Checkout/StripePortal';
import { useGlobal } from '../../Core/GlobalState/Store';
import PaymentService from '../../Core/Services/PaymentService';
import SettingsService from '../../Core/Services/SettingsService';

export default function FinalizePayment() {
  const { t } = useTranslation();
  const { pluginUrl } = useGlobal();

  //Local State
  const [total, setTotal] = useState(0);
  const [error, setError] = useState(null);
  const [currency, setCurrency] = useState('');
  const [options, setOptions] = useState(null);
  const [isReAuth, setIsReAuth] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [orderNumber, setOrderNumber] = useState('');
  const [invoiceNumber, setInvoiceNumber] = useState('');


  //Get order and invoice details, client secret for stripe and other necessary data to finalize the payment
  useEffect(() => {
    const fetchData = async () => {
      try {
        const searchParams = new URLSearchParams(window.location.search);
        const orderIdFromUrl = searchParams.get('orderId');
        const invoiceIdFromUrl = searchParams.get('invoiceId');
        const paymentIntentIdFromUrl = searchParams.get('paymentIntentId');
        const isReAuth = searchParams.get('reauth');
        setIsReAuth(isReAuth === 'true');

        const data = await PaymentService.getOrderFinalizationData(
          paymentIntentIdFromUrl,
          orderIdFromUrl,
          invoiceIdFromUrl,
          SettingsService.getCountryShortCode()
        );

        setOrderNumber(data.orderNumber);
        setInvoiceNumber(data.invoiceNumber);
        setTotal(data.totalPaymentAmount);
        setCurrency(data.currency);

        setOptions({
          clientSecret: data.clientSecret,
          customerSessionClientSecret: data.customerSessionClientSecret,
        });
        setIsLoading(false);
      } catch (err) {
        setError(t('error_loading_invoice_data'));
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <div
      className="w-full flex flex-col !border-solid !border-l !border-r border-gray-300 border-1"
      style={{
        backgroundImage: `linear-gradient(135deg, #fff 0%, rgba(255,255,255,0) 33.9%, #fff 100%), url(${pluginUrl + pattern})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'top right',
      }}
    >
      <div className="mb-2 h-[180px] md:h-[250px] text-center flex flex-col justify-center items-center">
        <div
          className="text-uppercase font-medium text-sm"
          style={{ color: '#BF4B30' }}
        >
          {t('header_current_step', {
            currentStep: 1,
            totalSteps: 1,
          })}
        </div>
        <h1 className="text-2xl md:text-5xl font-bold">
          {' '}
          {isReAuth ? t('finalize_your_payment') : t('finalize_your_booking')}
        </h1>
        <div>
          {isReAuth
            ? t('finalize_your_payment_description')
            : t('finalize_your_booking_description')}
        </div>
      </div>
      <div className="md:grid grid-cols-1 flex flex-col-reverse gap-6 md:grid-cols-12 !border !border-solid border-gray-400">
        <div className="col-span-12 md:col-span-7 p-4 md:min-h-[800px]">
          {error && <div className="text-red-600 font-bold">{error}</div>}
          {isLoading && <div>{t('loading')}</div>}
          {!isLoading && options && <StripePortal options={options} />}
        </div>
        <div className="col-span-12 md:col-span-5">
          <div className="p-8 flex flex-col gap-4  !border !border-solid border-borderblue mt-2 md:mt-0">
            <div
              className="font-medium text-sm"
              style={{ color: '#233F72', fontFamily: 'Roboto Mono' }}
            >
              {t('summary')}
            </div>
            <div>
              <div>
                <div className="font-bold text-base">
                  {' '}
                  {t('order_number')} {orderNumber}{' '}
                </div>
                <div className="font-bold text-base">
                  {t('invoice_number')} {invoiceNumber}{' '}
                </div>
              </div>
              <div>
                <hr />
                <div className="font-bold text-base">
                  {t('rental_contract_total')}
                </div>
              </div>
              <div className="!mt-6 flex justify-between">
                <div className="font-bold text-base">
                  {total} {currency}{' '}
                  <span className="font-normal text-sm">{t('incl_vat')}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
